<template>
    <div class="layout-default">
        <div class="layout-default__sidebar">
            <view-default-sidebar />
        </div>
        <div class="layout-default__main">
            <view-default-header />
            <router-view />
        </div>
    </div>
</template>

<script>
import ViewDefaultHeader from '../views/ViewDefault/ViewDefaultHeader';
import ViewDefaultSidebar from '../views/ViewDefault/ViewDefaultSidebar';
export default {
    name: 'LayoutDefault',
    components: {
        ViewDefaultHeader,
        ViewDefaultSidebar
    }
}
</script>

<style lang="scss" scoped>
    .layout-default {
        height: 100%;
        display: flex; 
        flex-direction: row; 
        align-content: flex-start;
    }
    .layout-default__sidebar {
        flex-grow: 0; 
        flex-shrink: 0;
        height: 97vh;
        position: sticky;
        top: 10px;
        background: #fff;
        margin: 10px 0 10px 10px;
        border-radius: 14px;
    }
    .layout-default__main {
        flex-grow: 1; 
        flex-shrink: 1;
        width: 90%;
        margin: 10px 0 10px 0;
        padding: 0 30px 0 30px;
        overflow: auto;
        flex: 1;
    }
    @media (max-width: 768px) {
        .layout-default{
            display: flex;
            flex-direction: column;
        }
        .layout-default__sidebar {
            height: auto;
        }
    }
</style>